import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import {WeaTools, WeaErrorPage, WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const { ls } = WeaTools;
import EHeader from '../common/EHeader';
import FooterMore from "../common/FooterMore";
import { NoRightCom } from '../../util/common';
//元素组件
class FnaBudgetAssistant1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edata: null,
            refresh: false,
            weaFnaLoaded: false
        }
        this.handleEData = this.handleEData.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }
    handleDelete(){
        this.setState({
            edata: null,
        });
        ls.set('edata-'+this.props.config.params.eid, null);
    }
    handleRefresh(){
        this.setState({
            refresh: true,
        });
        this.handleEData(this.props.config.params);
    }
    handleEData(params){
        const { eid, api } = params;
        this.setState({
            edata: ls.getJSONObj('edata-'+eid),
        });
        ls.set('edata-'+eid, {});
        this.setState({
            edata: {},
            refresh: false,
        });
    }
    componentWillMount() {
        // 异步加载财务模块静态资源
        eventRegister.loadModule('b_fna', ()=> {
            setTimeout(()=>this.setState({weaFnaLoaded:true}), 100);
        }, ()=> {});
    }
    componentDidMount(){
        this.handleEData(this.props.config.params);
    }
    componentWillReceiveProps(nextProps){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = { 
            item: nextProps.config.item, 
            params: nextProps.config.params, 
            isHasRight: nextProps.config.isHasRight,
        };
        if(!isEqual(config, _config) || nextProps.config.isRender){
            this.handleEData(nextProps.config.params);
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = { 
            item: nextProps.config.item, 
            params: nextProps.config.params, 
            isHasRight: nextProps.config.isHasRight,
        };
        return !isEqual(this.state, nextState) || !isEqual(config, _config)
    }
    render() {
        const { edata, refresh, weaFnaLoaded } = this.state;
        const { config, fontSizeMp } = this.props;
        if(!config || !edata) return <div/>;
        const { isHasRight, item, params } = config;
        const { eid, ebaseid, content, header, contentview, style } = item;
        const { style: style1= {} } = contentview;
        let EContentHtml = <div/>;
        if(isHasRight){
            EContentHtml = weaFnaLoaded && window.weaFnaEngine && window.weaFnaEngine.com ? <window.weaFnaEngine.com.ApprovalAssistantPage queryData={params} /> : <div></div>;
        }else{
            EContentHtml = <NoRightCom/>
        }
        return <div className="item"
                    style={style}
                    id={`item_${eid}`} 
                    data-eid={eid} data-ebaseid={ebaseid} 
                    data-needRefresh={item.needRefresh} 
                    data-cornerTop={item.cornerTop} 
                    data-cornerTopRadian={item.cornerTopRadian}
                    data-cornerBottom={item.cornerBottom} 
                    data-cornerBottomRadian={item.cornerBottomRadian}>
                    <EHeader config={config} handleRefresh={this.handleRefresh} handleDelete={this.handleDelete} fontSizeMp={fontSizeMp}/>
                    <div className="setting" id={`setting_${eid}`}></div>
                    <div className="content" id={`content_${eid}`} style={{width:'auto',_width:'100%'}}>
                        <div className="content_view" id={`content_view_id_${eid}`} style={{height: style1.height}}>
                            <Spin spinning={refresh}>{EContentHtml}</Spin>
                        </div>
                        <div style = {{textAlign:'right'}} id={`footer_${eid}`}><FooterMore config={this.props.config}/></div>
                    </div>
            </div>;
    }
}

class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
            return ( <WeaErrorPage msg = { hasErrorMsg ? this.props.error : getLabel(388017,"对不起，元素加载异常，请联系管理员！") }/>
        );
    }
}
FnaBudgetAssistant1 = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(FnaBudgetAssistant1);
export default FnaBudgetAssistant1;






// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/fnaBudgetAssistant1/index.js